<script setup lang="ts">
/**
 * Contact form wrapper — always rendered on every template because hero and
 * footer CTAs anchor to #contact.
 */
withDefaults(defineProps<{
  tenantName: string
  banded?: boolean
}>(), { banded: true })

const { t } = useI18n()
</script>

<template>
  <section
    id="contact"
    :class="banded ? 'bg-[var(--bg2)] border-y border-[var(--border)]' : ''"
  >
    <div class="mx-auto max-w-2xl px-6 py-20">
      <LandingContactForm
        :title="t('site.public_contact_title', { name: tenantName })"
        :subtitle="t('site.public_contact_subtitle')"
        :submit-label="t('site.public_contact_submit')"
      />
    </div>
  </section>
</template>
